import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { FundListingEntryComponent } from './fund-listing-entry/fund-listing-entry.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@shared/translate/translate.module';
import { FundListingComponent } from './fund-listing/fund-listing.component';
import { FootnoteModule } from '@components/shared/footnote';
import { SharedModule } from '@components/shared/shared.module';
import { FundCardsComponent } from './fund-cards/fund-cards.component';
import { HomeFundListingComponent } from "./home-fund-listing/home-fund-listing.component";
import { FundCompareComponent } from "@products/fund-listing/fund-compare/fund-compare.component";
import { EmptyPageComponent } from "@products/fund-listing/fund-compare/empty-page/empty-page.component";
import { FundWatchListComponent } from './fund-watch-list/fund-watch-list.component';
import { WatchListContentComponent } from './fund-watch-list/watch-list-content/watch-list-content.component';
/**
 * Module for GW PPSS component
 */
@NgModule({
  imports: [
    CommonModule,
    BrSdkModule,
    TranslateModule,
    FootnoteModule,
    RouterModule,
    SharedModule
  ],
  declarations: [
    FundListingEntryComponent,
    FundListingComponent,
    FundCardsComponent,
    HomeFundListingComponent,
    FundCompareComponent,
    EmptyPageComponent,
    FundWatchListComponent,
    WatchListContentComponent
    
  ],
})
export class FundListingModule implements DynamicModule {
  constructor() {
  }

  getComponentMapping(): ComponentMapping {
    return {
      'IND Fund Listing': FundListingEntryComponent,
    };
  }
}
